import { router } from '../../utils';
import { getTradingCompetition } from './getTradingCompetition';
import { getTradingCompetitionLeaderboard } from './getTradingCompetitionLeaderboard';
import { getUserTradingRank } from './getUserTradingRank';
import { isUserRegistered } from './isUserRegistered';
import { refreshUserScore } from './refreshUserScore';
import { registerToTradingCompetition } from './registerToTradingCompetition';
import { unregisterFromTradingCompetition } from './unregisterFromTradingCompetition';
export const tradingCompetitionContract = router({
    get: getTradingCompetition,
    getLeaderboard: getTradingCompetitionLeaderboard,
    getUserRank: getUserTradingRank,
    isUserRegistered: isUserRegistered,
    refreshUserScore: refreshUserScore,
    register: registerToTradingCompetition,
    unregister: unregisterFromTradingCompetition,
}, {
    pathPrefix: '/communities/:subdomain/trading-competition',
});
